import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';

@Component({
    selector: 'odq-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    standalone: false
})
export class InputComponent implements OnInit {
  @Input() colPercentSize = 0;

  @ViewChild('innerTemplate', { static: true })
  public innerTemplate: TemplateRef<any>;

  constructor() { }

  ngOnInit() {
  }

}
